// frontend/components/Layout/AuthLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="relative">
        {/* Decorative background */}
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
        
        {/* Main content */}
        <div className="relative z-10">
          <Outlet />
        </div>
        
        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 text-center py-4 text-sm text-gray-500">
          © 2024 Brominon Invoicing System. All rights reserved.
        </div>
      </div>
    </div>
  );
}